<template>
  <div>
    <!-- -->
    <el-card class="box-card">
      <el-row :gutter="10">
        <el-col :span="2">
          <span>
            <i :class="objectClass" class="el-icon-star-on"></i>
          </span>
        </el-col>
        <el-col :span="17">
          <span>{{ TotalTitle }}</span>
        </el-col>
        <el-col :span="5">
          <el-row type="flex" justify="end">
            <span style="float: right"
              ><strong :class="objectClass">{{ TotalNumber }} %</strong>
            </span>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "ClientRabbeyCardsTotalesKpiSlaPorClientes",
  props: {
    title: {
      type: String,
      default: "Total",
      required: true
    },
    total: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {};
  },

  mounted() {},
  computed: {
    TotalTitle() {
      return this.title;
    },
    TotalNumber() {
      return (this.total ?? 0).toFixed(2);
    },
    objectClass() {
      let isRed = false;
      let isOrange = false;
      let isGreen = false;

      if ((this.total ?? 0) < 80) {
        isRed = true;
      } else if ((this.total ?? 0) < 90) {
        isOrange = true;
      } else {
        isGreen = true;
      }

      return {
        Red: isRed,
        Orange: isOrange,
        Green: isGreen
      };
    }
  },
  methods: {}
};
</script>

<style scoped>
.Red {
  color: red;
}
.Orange {
  color: orange;
}
.Green {
  color: green;
}
</style>
